<template>
  <div style="height: 100%;"
    class="portal_page">
    <el-scrollbar class="scrollbar">
      <div class="place">
        <Header-Portal></Header-Portal>
        <transition name="scale"
          mode="out-in">
          <router-view></router-view>
        </transition>
        <Footer></Footer>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import HeaderPortal from '@/components/common/HeaderPortal.vue'
import Footer from '@/components/common/Footer.vue'
export default {
  data() {
    return {
    }
  },
  components: {
    HeaderPortal,
    Footer
  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.portal_page {
  width: 100%;
  height: 100%;
  background: #f7faff url("~@/assets/images/home/portal-bg.png") no-repeat;
  background-size: contain;
}
.scrollbar {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
  .el-scrollbar__view {
    height: 100%;
  }
}
.place {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

<style lang="scss">
:root {
  --accent-color: #0051d9;
  --content-background-color: #f1f5ff;
  --collapse-background-color: #f5f7fa;
  --footer-background-color: #1d2129;
  --text-color: #0f132c;
  --text2-color: #5f677b;
  --text3-color: #8f95a5;
  --text4-color: #c7cad2; //文本色/4.弱提示、不可用
  --index-title-color: #000000;
  --white-color: #ffffff;
  --shadow-color: rgba(77, 133, 232, 0.1);
  --dividing-line-color: rgba(235, 237, 240, 0.6); //分割线的颜色#EBEDF0
  --dividing-line2-color: #e7edf4;
}
.content {
  width: 1200px;
}
.ellipsis {
  overflow: hidden; /* 超出隐藏 */
  white-space: nowrap; /* 文本不换行 */
  text-overflow: ellipsis; /* 文本超出呈现方式：省略号 */
}
.multi-line-ellipsis {
  display: -webkit-box; //对象作为弹性伸缩盒子模型显示
  overflow: hidden; //溢出隐藏
  -webkit-box-orient: vertical; //设置伸缩盒子对象的子元素的排列方式
  -webkit-line-clamp: 2; //设置 块元素包含的文本行数
  text-overflow: ellipsis;
}
.multi-line-ellipsis-3 {
  display: -webkit-box; //对象作为弹性伸缩盒子模型显示
  overflow: hidden; //溢出隐藏
  -webkit-box-orient: vertical; //设置伸缩盒子对象的子元素的排列方式
  -webkit-line-clamp: 3; //设置 块元素包含的文本行数
  text-overflow: ellipsis;
}

.door-enter,
.door-leave-to {
  opacity: 0;
}
.door-enter-active,
.door-leave-active {
  transition: all 0.4s ease;
}

.door-enter-to,
.door-leave {
  opacity: 1;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s ease;
}

.scale-enter,
.scale-leave-to {
  opacity: 0.5;
  transform: scale(0.99);
}
.scale-enter-to,
.scale-leave {
  opacity: 1;
  transform: scale(1);
}
</style>


// WEBPACK FOOTER //
// src/views/portal/doorLayout.vue